var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "mb-5" }, [
      _c("div", { staticClass: "fields-wrapper is-divider mb-3" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                _vm._v("\n              Select light\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.lightType,
                        expression: "activeLight.lightType"
                      }
                    ],
                    staticClass: "custom-select",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.activeLight,
                            "lightType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.lightTypeChanged
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "point" } }, [
                      _vm._v("Point Light")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "spot" } }, [
                      _vm._v("Spot Light")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "directional" } }, [
                      _vm._v("Directional Light")
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label",
                  attrs: { for: "start_time" }
                },
                [_vm._v("\n              Start Time\n            ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeLight.startTime,
                      expression: "activeLight.startTime"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", id: "start_time" },
                  domProps: { value: _vm.activeLight.startTime },
                  on: {
                    change: function($event) {
                      return _vm.setDuration(_vm.index)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.activeLight,
                        "startTime",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label",
                  attrs: { for: "start_time" }
                },
                [_vm._v("\n              End Time\n            ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeLight.endTime,
                      expression: "activeLight.endTime"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", id: "end_time" },
                  domProps: { value: _vm.activeLight.endTime },
                  on: {
                    change: function($event) {
                      return _vm.setDuration(_vm.index)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.activeLight, "endTime", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                _vm._v("\n              Duration\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    id: "animation_duration_e",
                    readonly: ""
                  },
                  domProps: {
                    value: (
                      _vm.activeLight.endTime - _vm.activeLight.startTime
                    ).toFixed(2)
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label",
                  attrs: { for: "range" }
                },
                [_vm._v("\n              Range\n            ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeLight.range,
                      expression: "activeLight.range"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "number", id: "range" },
                  domProps: { value: _vm.activeLight.range },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.activeLight, "range", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label",
                  attrs: { for: "exposure" }
                },
                [_vm._v("\n              Exposure\n            ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeLight.exposure,
                      expression: "activeLight.exposure"
                    }
                  ],
                  attrs: { type: "range", min: "0", max: "2" },
                  domProps: { value: _vm.activeLight.exposure },
                  on: {
                    __r: function($event) {
                      return _vm.$set(
                        _vm.activeLight,
                        "exposure",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "ml-3" }, [
                  _vm._v(_vm._s(_vm.activeLight.exposure))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.activeLight.lightType == "spot"
              ? _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-4 col-form-label",
                        attrs: { for: "spotAngle" }
                      },
                      [_vm._v("\n              Spot Angle\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8" }, [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("span", { staticClass: "p-2" }, [_vm._v("Inner")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.activeLight.innerSpotAngle,
                              expression: "activeLight.innerSpotAngle"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            min: "0",
                            max: "360",
                            id: "innerangle"
                          },
                          domProps: { value: _vm.activeLight.innerSpotAngle },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.activeLight,
                                "innerSpotAngle",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "p-2" }, [_vm._v("Outer")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.activeLight.outerSpotAngle,
                              expression: "activeLight.outerSpotAngle"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            min: "0",
                            max: "360",
                            id: "outerangle"
                          },
                          domProps: { value: _vm.activeLight.outerSpotAngle },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.activeLight,
                                "outerSpotAngle",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6" }, [
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label",
                  attrs: { id: "color" }
                },
                [_vm._v("\n              Color\n            ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeLight.color,
                      expression: "activeLight.color"
                    }
                  ],
                  attrs: { type: "color", id: "favcolor", name: "favcolor" },
                  domProps: { value: _vm.activeLight.color },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.activeLight, "color", $event.target.value)
                    }
                  }
                }),
                _vm._v(
                  "\n\n              " +
                    _vm._s(_vm.activeLight.color) +
                    "\n\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                _vm._v("\n              Shadow Type\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.shadowType,
                        expression: "activeLight.shadowType"
                      }
                    ],
                    staticClass: "custom-select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.activeLight,
                          "shadowType",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "Soft" } }, [
                      _vm._v("Soft")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Hard" } }, [
                      _vm._v("Hard")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "None" } }, [_vm._v("None")])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                _vm._v("\n              Shadow Strength\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.activeLight.shadowStrength,
                      expression: "activeLight.shadowStrength"
                    }
                  ],
                  attrs: { type: "range", min: "0", max: "1", step: "0.1" },
                  domProps: { value: _vm.activeLight.shadowStrength },
                  on: {
                    __r: function($event) {
                      return _vm.$set(
                        _vm.activeLight,
                        "shadowStrength",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "ml-3" }, [
                  _vm._v(_vm._s(_vm.activeLight.shadowStrength))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label",
                  attrs: { for: "mode" }
                },
                [_vm._v("\n              Mode\n            ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.lightMode,
                        expression: "activeLight.lightMode"
                      }
                    ],
                    staticClass: "custom-select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.activeLight,
                          "lightMode",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "Realtime" } }, [
                      _vm._v("Realtime")
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                _vm._v("\n              Position of the origin\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.localPosition[0],
                        expression: "activeLight.localPosition[0]"
                      }
                    ],
                    staticClass: "form-control border-danger",
                    attrs: { type: "number", id: "position_of_the_origin_x" },
                    domProps: { value: _vm.activeLight.localPosition[0] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.activeLight.localPosition,
                          0,
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.localPosition[1],
                        expression: "activeLight.localPosition[1]"
                      }
                    ],
                    staticClass: "form-control border-success",
                    attrs: { type: "number", id: "position_of_the_origin_y" },
                    domProps: { value: _vm.activeLight.localPosition[1] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.activeLight.localPosition,
                          1,
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.localPosition[2],
                        expression: "activeLight.localPosition[2]"
                      }
                    ],
                    staticClass: "form-control border-secondary",
                    attrs: { type: "number", id: "position_of_the_origin_z" },
                    domProps: { value: _vm.activeLight.localPosition[2] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.activeLight.localPosition,
                          2,
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group align-items-center" }, [
              _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                _vm._v("\n              Rotation of the origin\n            ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.localRotation[0],
                        expression: "activeLight.localRotation[0]"
                      }
                    ],
                    staticClass: "form-control border-danger",
                    attrs: { type: "number", id: "rotation_of_the_origin_x" },
                    domProps: { value: _vm.activeLight.localRotation[0] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.activeLight.localRotation,
                          0,
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.localRotation[1],
                        expression: "activeLight.localRotation[1]"
                      }
                    ],
                    staticClass: "form-control border-success",
                    attrs: { type: "number", id: "rotation_of_the_origin_y" },
                    domProps: { value: _vm.activeLight.localRotation[1] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.activeLight.localRotation,
                          1,
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeLight.localRotation[2],
                        expression: "activeLight.localRotation[2]"
                      }
                    ],
                    staticClass: "form-control border-secondary",
                    attrs: { type: "number", id: "rotation_of_the_origin_z" },
                    domProps: { value: _vm.activeLight.localRotation[2] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.activeLight.localRotation,
                          2,
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-flex mb-4" }, [
      _c("h4", { staticClass: "mr-3 mb-0" }, [_vm._v("Light ")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae464e6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae464e6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/lights/maininspector.vue
// module id = null
// module chunks = 